<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="offcanvas-container">
  <div class="close-button-box cursor-pointer" (click)="closeModal()">
    <i class="fal fa-times"></i>
  </div>
  <div class="main-content-box">
    <!-- Chart Section -->
    <lfx-lf-box
      [version]="2"
      [sectionTitle]="title()"
      [isLoading]="false"
      class="chart-section">

      <div class="chart-wrapper">
        <div class="chart-container">
          <lfx-influence-chart
            [chartData]="chartData()"
            [size]="'large'">
          </lfx-influence-chart>
        </div>
      </div>
    </lfx-lf-box>

    @if (hasNullValues()) {
      <lfx-lf-box
        [version]="2">
        <div class="text-center">
          <span>{{ nullValueDescription() }}</span>
        </div>
      </lfx-lf-box>
    } @else {
      <!-- Summary table -->
      <lfx-lf-box
        [version]="2"
        [isLoading]="isSummaryTableLoading()"
        class="summary-table-section">

        @if (summaryTableError()) {
          <div class="text-center text-danger p-4">
            <i class="fas fa-exclamation-triangle mb-2"></i>
            <p>{{ summaryTableError() }}</p>
          </div>
        } @else {
          <lfx-new-table
            [columns]="summaryTableColumns()"
            [data]="summaryTableData()"
            [version]="2"
            [striped]="false"
            [useTablePagination]="true"
            [emptyDataMessage]="'No summary data available'">
          </lfx-new-table>
        }
      </lfx-lf-box>

      <!-- Table Section -->
      <lfx-lf-box
        [version]="2"
        [isLoading]="isTableLoading()"
        class="table-section">

        <!-- Widget Menu for Report Issue -->
        @if (widgetActions().length > 0) {
          <lfx-widget-menu
            [actions]="widgetActions()"
            position="top-right"
            (actionClicked)="handleWidgetAction($event)">
          </lfx-widget-menu>
        }

        @if (loadingError()) {
          <div class="text-center text-danger p-4">
            <i class="fas fa-exclamation-triangle mb-2"></i>
            <p>{{ loadingError() }}</p>
          </div>
        } @else {
          <lfx-new-table
            [columns]="tableColumns()"
            [data]="tableData()"
            [version]="2"
            [useTablePagination]="true"
            [emptyDataMessage]="'No data available'"
            (columnTextClickAction)="onColumnTextClick($event)">
          </lfx-new-table>
        }
      </lfx-lf-box>
    }
  </div>
</div>

<!-- Template for user profile cell -->
<ng-template #userProfileTemplate let-row="row.displayName">
  <lfx-user-profile-cell
    [name]="row.text"
    [imageUrl]="row.extraData?.imageUrl"
    [employeeId]="row.extraData?.userId"
    [options]="{ activity: { collapsed: false, defaultFilter: 'Technical' } }"
    [organizationName]="row.extraData?.organizationName"
  ></lfx-user-profile-cell>
</ng-template>
